import React from "react";
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb} from 'react-bootstrap';
import { Link } from 'react-router-dom';

const LibraryServices = () =>{
  
  return (
    <div className="Services">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/img/innerbanner/library-services.jpg"} alt="Library Services"/>
      </section>
     
      <section  className="research-box-area">
           <Container>
           <Breadcrumb>
                <BreadcrumbItem>
                  <Link as={Link} to="/">
                         Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link as={Link} to="/collaborative-working-and-learning-spaces">
                  Explore
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Library Services</BreadcrumbItem>
              </Breadcrumb>
              <div className='information-content'>
                <h2>Library Services</h2>
                <p>Habib University’s library team aims to provide students with adequate facilities for learning with passion. With a range of library and learning services available, it creates an environment that supports teaching, learning, and research. The library provides a stimulating user-centered environment, learning spaces, and customer services supported by digital technologies.</p>
              </div>
              <Row className="ParentBorderBox">
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <div>
                        <h5>Borrowing and Renewal Services</h5>
                        <p>We extend borrowing services to the HU community members (faculty, students, and staff) as per borrowing privileges, rules, and policies. Materials can be borrowed and returned to the circulation desks located on the first floor. The materials include course books, course packs, reference books, and academic journals. It is important to keep in mind that any material borrowed from the library is subject to recall. The renewals or re-issuance of materials can be done twice.</p>
                      </div>
                      
                    </div>
                  </Col>
                  
                  <Col lg={4} sm={6} className="bord">
                  <div className="research-box ">
                      <div>
                        <h5>Information Literacy Workshops and Library Orientation Sessions</h5>
                        <p>The HU library team organizes orientation sessions at the beginning of each semester to provide in-depth knowledge about the library and its services. Furthermore, information literacy workshops are also organized for the students to facilitate them to strengthen their literature searching, citation management, and research skills. The information literacy workshops are held in small groups or in the form of in-class sessions. Send email to <a href="mailto:library@habib.edu.pk">library@habib.edu.pk</a></p>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                  <div className="research-box">
                        <h5>Online Literature Searching for assignments and projects</h5>
                        <p>Library Staff helps HU community members through one-on-one training or workshops and facilitates them in conducting a literature search on a particular subject or topic and may facilitate in:</p>
                        <ul className="research-box-list"> 
                          <li>Sharing details of the right resources for your search.</li>
                          <li>Fine-tuning your search strategies.</li>
                          <li>Identifying materials closely related to the research topic.</li>
                          <li>Arranging and supplying full-text articles, if required.</li>
                          <li>Responding to queries related to accessibility and delivery.</li>
                        </ul>
                    </div>
                    
                  </Col>
                  
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <div>
                        <h5>Help desk</h5>
                        <p>Patrons may ask for IT Support related to printing, enabling internet on digital devices, the self-service portal, and the campus management system at the Information Commons ground floor. Call <a href="tel:+9221111042242;ext=4224">4224</a> for further assistance.</p>
                      </div>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <div>
                        <h5>Inter-Library Loan</h5>
                        <p>In case the HU community needs an item not available in the existing library collection (print book or online article), the library will attempt to borrow it from another library within the city through an ‘Inter-Library Loan’ arrangement.  For further assistance e-mail at <a href="mailto:illp@habib.edu.pk">illp@habib.edu.pk</a>.</p>
                      </div>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                  <div className="research-box">
                      <div>
                        <h5>Online Chat Reference</h5>
                        <p>The 24*7 live chatbot is available on the bottom right for immediate queries.</p>
                      </div>
                      
                    </div>
                    
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                  
                  <div className="research-box">
                      <div>
                        <h5>Reference Services</h5>
                        <p>Our team is available to provide proactive reference services from 9.00 a.m. to 6.30 p.m. Call <a href="tel:+9221111042242;ext=7105">7105</a>  for further assistance.</p>
                      </div>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                  <div className="research-box">
                    <h5>Library Forms</h5>
                    <ul>
                      <li>
                          <a target="_blank" href="https://habibuniversity.sharepoint.com/sites/Staff/Pages/Library-Resource-Request.aspx" className="link-btn">
                            <img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt=""/>
                            Book(s) Purchase Request Form
                          </a>
                      </li>
                      <li>
                        <a target="_blank" href="https://habibuniversity.sharepoint.com/sites/Student/hira-metadata-form" className="link-btn">
                          <img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt=""/>
                          FYP/Thesis Submission Form
                        </a>
                      </li>
                      <li>
                          <a target="_blank" href="https://tinyurl.com/mrx5hcbb" className="link-btn">
                            <img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt=""/>
                            Patron Registration
                          </a>
                      </li>
                      
                      <li>
                          <a target="_blank" href="https://habibuniversity.sharepoint.com/sites/intranet/Pages/Inter-Library-Loan.aspx?xsdata=MDV8MDJ8bWFzaGhvb2QuYW53YXJAaGFiaWIuZWR1LnBrfGQ0N2NlMzNiZWU1NjRjZmVkNjQxMDhkZjBhNWM0MDc3fDcwYzM1YWE0YmVkNDQ4ZjI5NWM5ZTNiYTJmN2MwMzdhfDB8MHw2MzkyNDEwNjM0OTkwMDA2ODZ8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=TXdJRHdjNyt5WnVKUGpodVRwekRwWFRaV0JmS2ZEQzNMOXdPeWVFVVJhdz0%3d" 
                          className="link-btn">
                            <img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt=""/>
                            Inter Library Loan form 
                          </a>
                      </li>
                    </ul>
                  </div>
                  </Col>
              </Row>
           </Container>
      </section>
     
    </div>
  );
}
export default LibraryServices;